module.exports = __webpack_public_path__ + "media/images/items/static-8-bdadd394688f550a6c7272f43f454086.jpg";